/**
 * local storage に Local UID および Plan Type が存在していれば、認証済みとみなす
 * */
const isAuthenticated = (): boolean => {
  const localUid = localStorage.getItem(process.env.LOCAL_UID_KEY!)
  const planType = localStorage.getItem(process.env.SELECTED_PLAN_TYPE!)
  return !!localUid && !!planType
}

/**
 * local storage から Local UID および Plan Type を削除する
 * */
const removeAuthParameters = (): void => {
  localStorage.removeItem(process.env.LOCAL_UID_KEY!)
  localStorage.removeItem(process.env.SELECTED_PLAN_TYPE!)
}

/**
 * local storage から Local UID を取得する
 * */
const getLocalUid = (): string | null => {
  return localStorage.getItem(process.env.LOCAL_UID_KEY!)
}

/**
 * local storage に Local UID を保存する
 * */
const setLocalUid = (uid: string): void => {
  localStorage.setItem(process.env.LOCAL_UID_KEY!, uid)
}

/**
 * local storage から Plan Type を取得する
 * */
const getSelectedPlanType = (): string | null => {
  return localStorage.getItem(process.env.SELECTED_PLAN_TYPE!)
}

/**
 * local storage に Plan Type を保存する
 * */
const setSelectedPlanType = (planType: string): void => {
  localStorage.setItem(process.env.SELECTED_PLAN_TYPE!, planType)
}

/**
 * local storage から初回ログインフラグを取得する
 * 取得できなかった場合や、'false' 以外の値の場合は true を返す
 * */
const isFirstLogin = (): boolean => {
  const flag = localStorage.getItem(process.env.IS_FIRST_LOGIN!)
  return flag !== 'false'
}

/**
 * local storage の初回ログインフラグを false に設定する
 * */
const offFirstLoginFlag = (): void => {
  localStorage.setItem(process.env.IS_FIRST_LOGIN!, 'false')
}

export {
  isAuthenticated,
  removeAuthParameters,
  getLocalUid,
  setLocalUid,
  getSelectedPlanType,
  setSelectedPlanType,
  isFirstLogin,
  offFirstLoginFlag,
}
